export const getOwner = state => state.owner;
export const getOwnerData = state => state.owner.ownerData;
